import React from 'react';
import { FadeIn, Section } from './Section';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <Section bg="blush" className="text-center border-y border-plum/5" data-id="element-149">
      <FadeIn className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-150">
        <div className="w-16 h-16 md:w-20 md:h-20 bg-plum text-cream rounded-full flex items-center justify-center mb-6 md:mb-8 shadow-xl shadow-plum/10" data-id="element-151">
          <ShieldCheckIcon size={32} className="md:w-10 md:h-10" data-id="element-152" />
        </div>

        <h2 className="font-serif text-3xl md:text-5xl text-plum mb-4 md:mb-6" data-id="element-153">
          7 Días de Garantía Total
        </h2>

        <p className="text-base md:text-xl text-plum/80 font-medium mb-4 md:mb-6" data-id="element-154">
          Probalo sin riesgo. Si no es lo que esperabas, te devolvemos el 100%.
        </p>

        <p className="text-sm md:text-base text-plum/70 leading-relaxed mb-6 md:mb-8" data-id="element-155">
          Abrís el ebook, trabajás los módulos, usás los bonos. Si en los
          primeros 7 días sentís que no es para vos: sin preguntas, sin
          formularios, sin drama. Te devolvemos cada peso.
        </p>

        <p className="text-[10px] md:text-sm font-bold tracking-widest uppercase text-plum/50" data-id="element-156">
          (Tasa de devoluciones menor al 1%)
        </p>
      </FadeIn>
    </Section>;
}